import {
  FETCH_MISSIONS_FAILURE,
  FETCH_MISSIONS_LOADING,
  FETCH_MISSIONS_SUCCESS
} from '../Types/missionTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: false,
  item: {},
  cityCap: {},
  filters: {},
  step: null
};

const missionReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_MISSIONS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
        data: [],
        cityCap: {},
        total: 0
      };

    case FETCH_MISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload.data,
        total: action.payload.total
      };

    case FETCH_MISSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
        data: []
      };

    default:
      return { ...state };
  }
};

export default missionReducer;
